import { IAPIOrderDetailModel, IAPIOrderDetailPageModel } from "../interfaces";

export class OrderDetailPageModel {
    detail: OrderDetailModel;
    constructor(data: Partial<OrderDetailPageModel> = {}) {
        this.detail = data?.detail || new OrderDetailModel();
    }

    static deserializeAPIModel(data: IAPIOrderDetailPageModel): OrderDetailPageModel {
        return new OrderDetailPageModel({ detail: data.detail });
    }
}

export class OrderDetailModel {
    status: string;
    orderNo: string;
    createdDate: string;
    createdBy: string;
    reference: string;
    orderId: string;
    paymentMethod: string;
    merchantAccount: string;
    billTo: string;
    shipTo: string;
    usedBy: string;

    constructor(data: Partial<OrderDetailModel> = {}) {
        this.status = data.status || '';
        this.orderNo = data.orderNo || '';
        this.createdDate = data.createdDate || '';
        this.createdBy = data.createdBy || '';
        this.reference = data.reference || '';
        this.orderId = data.orderId || '';
        this.paymentMethod = data.paymentMethod || '';
        this.merchantAccount = data.merchantAccount || '';
        this.billTo = data.billTo || '';
        this.shipTo = data.shipTo || '';
        this.usedBy = data.usedBy || '';
    }

    static deserializeAPIModel(data: Partial<IAPIOrderDetailModel>): OrderDetailModel {
        return new OrderDetailModel({
            status: data.status,
            orderNo: data.orderNo,
            createdDate: data.createdDate,
            createdBy: data.createdBy,
            reference: data.reference,
            orderId: data.orderId,
            paymentMethod: data.paymentMethod,
            merchantAccount: data.merchantAccount,
            billTo: data.billTo,
            shipTo: data.shipTo,
            usedBy: data.usedBy,
        });
    }
}
